<script setup lang="ts">
import { useAutobidAuth } from '@autobid/nuxt-auth/src/composables/useAutobidAuth'
import { useLocalRef } from '@autobid/ui/composables/useLocalRef'

interface Props {
  link: string
}

defineProps<Props>()
const opened = ref(false)
const shouldNotDisplayed = useLocalRef(
  'shouldNotDisplayedAggregateRedirection',
  false,
)

const { isAuthed } = useAutobidAuth()

defineExpose({
  opened,
  shouldNotDisplayed,
})
</script>

<template>
  <CommonDialog :opened="opened" @close="opened = false">
    <template #title>
      {{ $t('aggregate-modal.title') }}
    </template>
    <template #content>
      <p>
        {{ $t('aggregate-modal.content') }}
      </p>
      <ElementsCheckbox
        class="my-2"
        small
        :label="$t('aggregate-modal.dont-show-again')"
        :checked="shouldNotDisplayed"
        @change="(v) => (shouldNotDisplayed = v)"
      />
    </template>
    <template #buttons>
      <div class="flex flex-wrap-reverse items-center justify-between gap-4">
        <ElementsButton class="w-max" @click="opened = false">
          {{ $t('aggregate-modal.cancel') }}
        </ElementsButton>
        <ElementsButton
          :url="`${link}${isAuthed ? '?authenticated=1' : ''}`"
          class="w-max"
          @click="opened = false"
        >
          {{ $t('aggregate-modal.forward-to-alphabet') }}
        </ElementsButton>
      </div>
    </template>
  </CommonDialog>
</template>
